// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tenant-administrator-new-customer-user-type-parent-container{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    height: 100vh;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.45);
}
.tenant-administrator-new-customer-user-type-container{
    width: 400px;
    position: absolute;
    border-radius: 8px;
    background-color: white;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.tenant-administrator-new-customer-user-type-header{
    margin: 0px;
    padding: 10px 25px;
    width: 100%;
    color: white;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 7px 7px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
}
.tenant-administrator-new-customer-user-type-header h1{
    margin: 0px;
    font-size: 20px;
    font-weight: 600;
}
.tenant-administrator-new-customer-user-type-header p{
    margin: 0px;
    cursor: pointer;
    font-size: 18px;
    font-weight: 400;
}
.tenant-administrator-new-customer-user-type-select-container{
    margin: 38px 25px;
    padding-top: 12px;
    margin-bottom: 28px;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid gray;
    border-radius: 2px 2px 0px 0px;
    background-color: rgba(222, 229, 233,0.6);
}
.tenant-administrator-new-customer-user-type-select-container select{
    width: 100%;
    border: none;
    outline: none;
    padding: 5px;
    background-color: transparent;
}
.tenant-administrator-new-customer-user-type-buttons-container{
    width: 96%;
    margin: 20px 0px;
    text-align: right;
}
.tenant-administrator-new-customer-user-type-buttons-container button{
    padding: 10px 25px;
    margin: 0px 10px;
    border-radius: 4px;
    border: none;
    cursor: pointer;
    color: white;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
    background-color: rgba(155, 30, 30, 0.952);
    transition: opacity 0.2s ease;
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Customers/CustomerUsers/NewCustomerUserType.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;AACzC;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,0CAA0C;IAC1C,4DAA4D;AAChE;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,8BAA8B;IAC9B,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,6BAA6B;IAC7B,8BAA8B;IAC9B,yCAAyC;AAC7C;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,6BAA6B;AACjC;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,sCAAsC;IACtC,0CAA0C;IAC1C,6BAA6B;AACjC","sourcesContent":[".tenant-administrator-new-customer-user-type-parent-container{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 100;\r\n    height: 100vh;\r\n    width: 100vw;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: rgba(0, 0, 0, 0.45);\r\n}\r\n.tenant-administrator-new-customer-user-type-container{\r\n    width: 400px;\r\n    position: absolute;\r\n    border-radius: 8px;\r\n    background-color: white;\r\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.tenant-administrator-new-customer-user-type-header{\r\n    margin: 0px;\r\n    padding: 10px 25px;\r\n    width: 100%;\r\n    color: white;\r\n    box-sizing: border-box;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    border-radius: 7px 7px 0px 0px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n.tenant-administrator-new-customer-user-type-header h1{\r\n    margin: 0px;\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n}\r\n.tenant-administrator-new-customer-user-type-header p{\r\n    margin: 0px;\r\n    cursor: pointer;\r\n    font-size: 18px;\r\n    font-weight: 400;\r\n}\r\n.tenant-administrator-new-customer-user-type-select-container{\r\n    margin: 38px 25px;\r\n    padding-top: 12px;\r\n    margin-bottom: 28px;\r\n    display: flex;\r\n    justify-content: center;\r\n    border-bottom: 1px solid gray;\r\n    border-radius: 2px 2px 0px 0px;\r\n    background-color: rgba(222, 229, 233,0.6);\r\n}\r\n.tenant-administrator-new-customer-user-type-select-container select{\r\n    width: 100%;\r\n    border: none;\r\n    outline: none;\r\n    padding: 5px;\r\n    background-color: transparent;\r\n}\r\n.tenant-administrator-new-customer-user-type-buttons-container{\r\n    width: 96%;\r\n    margin: 20px 0px;\r\n    text-align: right;\r\n}\r\n.tenant-administrator-new-customer-user-type-buttons-container button{\r\n    padding: 10px 25px;\r\n    margin: 0px 10px;\r\n    border-radius: 4px;\r\n    border: none;\r\n    cursor: pointer;\r\n    color: white;\r\n    box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    transition: opacity 0.2s ease;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
